var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "activate" }, [
    _c(
      "div",
      { staticClass: "activate-form" },
      [
        _c(
          "default-layout",
          {
            attrs: {
              title: _vm.t("ActivatePage.pageTitle"),
              "sub-title": _vm.t("ActivatePage.subTitle"),
            },
          },
          [
            _c("sm-form", {
              ref: "form",
              attrs: { disabled: _vm.loading },
              on: { submit: _vm.handleSubmit },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function () {
                    return [
                      _c("input", {
                        staticClass: "sr-only",
                        attrs: {
                          type: "email",
                          name: "email",
                          "auto-complete": "username",
                        },
                        domProps: { value: _vm.email || _vm.user.email },
                      }),
                      _vm._v(" "),
                      _c(
                        "fieldset",
                        {
                          attrs: {
                            "data-heap-redact-attributes": "value",
                            "data-heap-redact-text": "true",
                            disabled: _vm.loading,
                          },
                        },
                        [
                          _vm.email
                            ? _c("sm-input", {
                                attrs: {
                                  "data-heap-redact-text": "true",
                                  "data-testid": "activate-email",
                                  value: _vm.email,
                                  type: "email",
                                  name: "displayEmail",
                                  label: _vm.t("LoginPage.emailLabel"),
                                  disabled: "",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("sm-input", {
                            ref: "password",
                            attrs: {
                              "data-heap-redact-text": "true",
                              type: "password",
                              name: "password",
                              "auto-complete": "new-password",
                              autofocus: "",
                              label: _vm.t("ActivatePage.passwordLabel"),
                              placeholder: _vm.t(
                                "ActivatePage.passwordPlaceholder"
                              ),
                              rules: "required|password",
                            },
                            model: {
                              value: _vm.draft.password,
                              callback: function ($$v) {
                                _vm.$set(_vm.draft, "password", $$v)
                              },
                              expression: "draft.password",
                            },
                          }),
                          _vm._v(" "),
                          _c("sm-input", {
                            ref: "confirmPassword",
                            attrs: {
                              "data-heap-redact-text": "true",
                              type: "password",
                              name: "confirmPassword",
                              "auto-complete": "new-password",
                              label: _vm.t("ActivatePage.confirmPasswordLabel"),
                              placeholder: _vm.t(
                                "ActivatePage.confirmPasswordPlaceholder"
                              ),
                              rules: "required|password",
                            },
                            model: {
                              value: _vm.draft.confirmPassword,
                              callback: function ($$v) {
                                _vm.$set(_vm.draft, "confirmPassword", $$v)
                              },
                              expression: "draft.confirmPassword",
                            },
                          }),
                          _vm._v(" "),
                          !_vm.hideSecretQuestion
                            ? _c("sm-select", {
                                attrs: {
                                  label: _vm.t(
                                    "ActivatePage.secretQuestionLabel"
                                  ),
                                  options: _vm.secretQuestions,
                                  placeholder: _vm.t(
                                    "ActivatePage.secretQuestionPlaceholder"
                                  ),
                                  rules: "required",
                                },
                                model: {
                                  value: _vm.draft.secretQuestion,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.draft, "secretQuestion", $$v)
                                  },
                                  expression: "draft.secretQuestion",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.hideSecretQuestion
                            ? _c("sm-input", {
                                attrs: {
                                  name: "secretAnswer",
                                  label: _vm.t(
                                    "ActivatePage.secretAnswerLabel"
                                  ),
                                  placeholder: _vm.t(
                                    "ActivatePage.secretAnswerPlaceholder"
                                  ),
                                  rules: "required",
                                },
                                model: {
                                  value: _vm.draft.secretAnswer,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.draft, "secretAnswer", $$v)
                                  },
                                  expression: "draft.secretAnswer",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "sm-button",
                            {
                              attrs: {
                                type: "primary",
                                "native-type": "submit",
                                loading: _vm.loading,
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.t("ActivatePage.submitButton")) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "fieldset",
                        [
                          _vm.errorMessage
                            ? _c("sm-help-card", {
                                attrs: { type: "warning" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "header",
                                      fn: function () {
                                        return [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.t(
                                                  "ActivatePage.error.passwordHistory"
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  3925534613
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }